import { Dashboard } from "@/features/dashboard/Dashboard";
import { GlobalAdminDashboard } from "@/components/GlobalAdminDashboard";
import { useAuthSession } from "@/hooks/useAuthSession";

export const DashboardRouter = () => {
  const { data: session } = useAuthSession();

  const isGlobalAdmin = session?.isGlobalAdmin ?? false;
  const isActingAsCompany = Boolean(session?.effectiveCompanyId);
  const showAdminDashboard = isGlobalAdmin && !isActingAsCompany;

  return (
    <div className="container mx-auto px-6 py-8">
      {showAdminDashboard ? <GlobalAdminDashboard /> : <Dashboard />}
    </div>
  );
};
